(function (root, factory) {
  if (root && root.NBBAnalytics && root.NBBAnalytics.VERSION === '1') return;
  var api = factory(root);
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.NBBAnalytics = api;
})(typeof window !== 'undefined' ? window : null, function (root) {
  'use strict';

  var EVENT_NAMES = [
    'popup_eligible',
    'popup_coverage',
    'popup_teaser_viewed',
    'popup_opened',
    'popup_step_viewed',
    'popup_interaction_started',
    'popup_scratch_started',
    'popup_email_attempted',
    'popup_signup_completed',
    'popup_offer_revealed',
    'popup_profile_started',
    'popup_profile_step_completed',
    'popup_profile_step_skipped',
    'popup_profile_completed',
    'popup_coupon_copied',
    'popup_dismissed',
    'popup_error',
    'discount_page_viewed',
    'discount_claim_started',
    'discount_claim_completed',
    'discount_coupon_copied',
    'discount_shop_clicked',
    'discount_error',
    'blog_block_viewed',
    'blog_block_clicked',
    'blog_article_viewed',
    'blog_read_progress',
    'blog_commerce_link_clicked',
    'blog_navigation_clicked'
  ];
  var EVENT_SET = new Set(EVENT_NAMES);
  var STRING_PARAMETERS = new Set([
    'popup_id', 'popup_version', 'popup_variant', 'popup_surface', 'popup_trigger',
    'experiment_id', 'step_id', 'page_type', 'article_handle', 'blog_type',
    'block_type', 'block_slot', 'destination_type', 'destination_handle',
    'error_category', 'device_type', 'locale'
  ]);
  var INTEGER_PARAMETERS = new Set(['step_number', 'destination_position', 'read_depth']);
  var BOOLEAN_PARAMETERS = new Set(['is_returning_claim']);
  var PII_KEYS = new Set([
    'email', 'name', 'firstname', 'lastname', 'phone', 'coupon', 'couponcode',
    'profileid', 'customerid', 'shopifycustomerid', 'modeltext', 'exactmodel',
    'turnstiletoken', 'orderemail'
  ]);
  var EXPOSURE_STORAGE_KEY = 'nbb_analytics_exposure_id_v1';
  var MAX_QUEUE = 50;
  var MAX_QUEUE_AGE_MS = 10 * 1000;
  var RETRY_DELAY_MS = 250;

  function normalizedKey(key) {
    return String(key || '').replace(/[^a-z0-9]/gi, '').toLowerCase();
  }

  function create(options) {
    options = options || {};
    var runtime = options.runtime || root || {};
    var storage = options.storage || runtime.sessionStorage || null;
    var now = options.now || Date.now;
    var setTimer = options.setTimeout || (runtime.setTimeout && runtime.setTimeout.bind(runtime)) || setTimeout;
    var clearTimer = options.clearTimeout || (runtime.clearTimeout && runtime.clearTimeout.bind(runtime)) || clearTimeout;
    var queue = [];
    var retryTimer = null;
    var memoryExposureId = '';

    function randomUUID() {
      if (typeof options.randomUUID === 'function') return options.randomUUID();
      var cryptoObject = runtime.crypto || (typeof crypto !== 'undefined' ? crypto : null);
      if (cryptoObject && typeof cryptoObject.randomUUID === 'function') return cryptoObject.randomUUID();
      var bytes = new Uint8Array(16);
      if (cryptoObject && typeof cryptoObject.getRandomValues === 'function') cryptoObject.getRandomValues(bytes);
      else for (var index = 0; index < bytes.length; index += 1) bytes[index] = Math.floor(Math.random() * 256);
      bytes[6] = (bytes[6] & 15) | 64;
      bytes[8] = (bytes[8] & 63) | 128;
      var hex = Array.prototype.map.call(bytes, function (value) { return value.toString(16).padStart(2, '0'); }).join('');
      return [hex.slice(0, 8), hex.slice(8, 12), hex.slice(12, 16), hex.slice(16, 20), hex.slice(20)].join('-');
    }

    function exposureId() {
      if (memoryExposureId) return memoryExposureId;
      try { memoryExposureId = storage && storage.getItem(EXPOSURE_STORAGE_KEY) || ''; }
      catch (_error) { memoryExposureId = ''; }
      if (!memoryExposureId) {
        memoryExposureId = randomUUID();
        try { if (storage) storage.setItem(EXPOSURE_STORAGE_KEY, memoryExposureId); }
        catch (_error) {}
      }
      return memoryExposureId;
    }

    function containsPiiKey(payload) {
      return Object.keys(payload || {}).some(function (key) { return PII_KEYS.has(normalizedKey(key)); });
    }

    function sanitize(payload) {
      var safe = {};
      Object.keys(payload || {}).forEach(function (key) {
        var value = payload[key];
        if (STRING_PARAMETERS.has(key) && value !== undefined && value !== null && value !== '') {
          safe[key] = String(value).slice(0, 100);
        } else if (INTEGER_PARAMETERS.has(key) && Number.isFinite(Number(value))) {
          safe[key] = Math.trunc(Number(value));
        } else if (BOOLEAN_PARAMETERS.has(key) && typeof value === 'boolean') {
          safe[key] = value;
        }
      });
      safe.event_id = randomUUID();
      safe.exposure_id = exposureId();
      safe.occurred_at = new Date(now()).toISOString();
      return safe;
    }

    function analytics() {
      return runtime.Shopify && runtime.Shopify.analytics;
    }

    function send(record) {
      var client = analytics();
      if (!client || typeof client.publish !== 'function') return false;
      try {
        client.publish.call(client, 'nbb:' + record.eventName, record.payload);
        return true;
      } catch (_error) {
        return false;
      }
    }

    function pruneExpired() {
      var cutoff = now() - MAX_QUEUE_AGE_MS;
      queue = queue.filter(function (record) { return record.queuedAt >= cutoff; });
    }

    function scheduleFlush() {
      if (retryTimer !== null || !queue.length) return;
      retryTimer = setTimer(function () {
        retryTimer = null;
        flush();
      }, RETRY_DELAY_MS);
    }

    function flush() {
      pruneExpired();
      if (!queue.length) return;
      var remaining = [];
      queue.forEach(function (record) {
        if (!send(record)) remaining.push(record);
      });
      queue = remaining;
      if (queue.length) scheduleFlush();
    }

    function publish(eventName, payload) {
      if (!EVENT_SET.has(eventName) || !payload || typeof payload !== 'object' || containsPiiKey(payload)) return false;
      var record = { eventName: eventName, payload: sanitize(payload), queuedAt: now() };
      if (send(record)) return true;
      queue.push(record);
      if (queue.length > MAX_QUEUE) queue.splice(0, queue.length - MAX_QUEUE);
      scheduleFlush();
      return true;
    }

    function destroy() {
      if (retryTimer !== null) clearTimer(retryTimer);
      retryTimer = null;
      queue = [];
    }

    return {
      publish: publish,
      flush: flush,
      pendingCount: function () { pruneExpired(); return queue.length; },
      destroy: destroy
    };
  }

  var singleton = create({ runtime: root || {} });
  return {
    VERSION: '1',
    EVENT_NAMES: EVENT_NAMES.slice(),
    create: create,
    publish: singleton.publish,
    flush: singleton.flush,
    pendingCount: singleton.pendingCount
  };
});
